
import React, { useEffect, useState } from 'react'
import {
  Box,
  Button,
  Checkbox,
  Image,
  Input,
  InputGroup,
  InputLeftAddon,
  InputLeftElement,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  NumberInput,
  NumberInputField,
} from '@chakra-ui/react';
import { DealerProfileType, } from '@masterffl/dealer-profile-component';
import AriaSelectDropdown from '@/common/AriaSelectDropdown';
import { businessPhoneLabels } from '@/utils/constants';
import { EditValuesToBeSavedInterface, FeesInterface } from '@/model/editDetails.mjs';
import { useDispatch } from 'react-redux';
import { isString } from 'lodash';
import './style.scss';
import { callToCreateDealerAction, setDealerActionsToBeSaved, setIsCreateDealerActionCompleted, setIsCreateDealerActionInprogress } from '@/explore/ducks/slice';
import { getDealerActionsToBeSaved, getIsCreateDealerActionCompleted, getIsCreateDealerActionInprogress } from '@/explore/ducks/selectors';
 
interface StoreContactDetailsEditProps {
  isTransferServicesEditOpen: boolean,
  onTransferServicesEditClose: () => void,
  dealerDetail?: DealerProfileType,
  dealerId: string,
 
}
 
 
 
const StoreTransferEdit = ({ isTransferServicesEditOpen, onTransferServicesEditClose, dealerDetail, dealerId }: StoreContactDetailsEditProps) => {
  console.log({ StoreTransferEdit: dealerDetail });
  const licenseKey = dealerDetail?.primaryInboundDetails.licenseKey || '';
  const dealerActionsToBeSaved = getDealerActionsToBeSaved();
  const isCreateDealerActionCompleted = getIsCreateDealerActionCompleted();
  const isCreateDealerActionInprogress = getIsCreateDealerActionInprogress();
  const initialValues = {
    nics_fee: null,
    discount_multiple_firearms: null,
    suppressor_fee: null,
    pistol_fee: null,
    rifle_fee: null,
    sbr_fee: null,
    pistol_enabled: false,
    rifle_enabled: false,
    sbr_enabled: false,
  };
  const transferFees = {
    pistol_enabled: dealerDetail?.fees ? Number(dealerDetail?.fees.handGun.enabled) : false,
    rifle_enabled: dealerDetail?.fees ? Number(dealerDetail?.fees.longGun.enabled) : null,
    sbr_enabled: dealerDetail?.fees ? Number(dealerDetail?.fees.other.enabled) : null,
    rifle_fee: dealerDetail?.fees ? Number(dealerDetail?.fees.longGun.value) : null,
    pistol_fee: dealerDetail?.fees ? Number(dealerDetail?.fees.handGun.value) : null,
    sbr_fee: dealerDetail?.fees ? Number(dealerDetail?.fees.other.value) : null,
    nics_fee: dealerDetail?.fees ? Number(dealerDetail?.fees.nics.value) : null,
    discount_multiple_firearms: dealerDetail?.fees ? Number(dealerDetail?.fees.discountForMultipleFirearms.value) : null,
    suppressor_fee: dealerDetail?.fees ? Number(dealerDetail?.fees?.nfaFee?.value) : null
  }
  const dispatch = useDispatch();
  const [editValues, setEditValues] = useState<FeesInterface>(initialValues);
  useEffect(() => {
    setEditValues({
      nics_fee: Number(dealerDetail?.fees.nics.value),
      discount_multiple_firearms: Number(dealerDetail?.fees.discountForMultipleFirearms.value),
      suppressor_fee: Number(dealerDetail?.fees?.nfaFee?.value),
      pistol_fee: Number(dealerDetail?.fees.handGun.value),
      rifle_fee: Number(dealerDetail?.fees.longGun.value),
      sbr_fee: Number(dealerDetail?.fees.other.value),
      pistol_enabled: dealerDetail?.fees.handGun.enabled,
      rifle_enabled: dealerDetail?.fees.longGun.enabled,
      sbr_enabled: dealerDetail?.fees.other.enabled
    });
  }, [dealerDetail]);
 
  useEffect(() => {
    return () => {
      dispatch(setDealerActionsToBeSaved([]));
      dispatch(setIsCreateDealerActionInprogress(false))
    };
  }, []);
 
  useEffect(() => {
    if(!isCreateDealerActionInprogress && isCreateDealerActionCompleted){
      onTransferServicesEditClose();
      dispatch(setIsCreateDealerActionCompleted(false));
    }
  }, [isCreateDealerActionInprogress,isCreateDealerActionCompleted])
  
  function onChangeHandler(
    fielddName: string,
    value: boolean | string,
    type: string
  ) {
    if (isString(value) && value.length > 5) {
      return;
    }
    if (type === 'status'){
        
      setEditValues({ ...editValues, [fielddName]: value });
    } else {
      const isValid = validateNumber(value.toString());
      if (isValid) {
        
        setEditValues({ ...editValues, [fielddName]: value });
      }
    }
      
    
    type transferTransferFeesKeyType = keyof typeof transferFees;
    if (
      (type === 'status' &&
        (transferFees && transferFees[fielddName as transferTransferFeesKeyType] !== value)) ||
      (type === 'fee' &&
        transferFees &&
        transferFees[fielddName as transferTransferFeesKeyType] !==
        Number(value))
    )
      updateDealerAction({
        value,
        name: fielddName,
        license_key: licenseKey,
        type: 'add'
      });
    else {
      updateDealerAction(
        { value, name: fielddName, license_key: licenseKey, type: 'add' },
        true
      );
    }
  }
  const updateDealerAction = (
    editParams: EditValuesToBeSavedInterface,
    isAlreadyExist?: boolean
  ) => {
    if (isAlreadyExist) {
      const actions = dealerActionsToBeSaved.filter(
        (action) => action.name != editParams.name
      );
      dispatch(setDealerActionsToBeSaved(actions));
      return;
    }
    let recordExist = false;
    const actions = dealerActionsToBeSaved.map((action) => {
      if (action.name === editParams.name) {
        recordExist = true;
        return editParams;
      }
      return action;
    });
    if (recordExist) dispatch(setDealerActionsToBeSaved(actions));
    else
      dispatch(
        setDealerActionsToBeSaved([...dealerActionsToBeSaved, editParams])
      );
  };
 
  const onSaveHandler = async () => {
    console.log({ dealerActionsToBeSaved });
    await dispatch(setIsCreateDealerActionInprogress(true))
    dispatch(callToCreateDealerAction({ actionList: dealerActionsToBeSaved , dealerId: dealerId}));
    
  };
  const validateNumber = (value: string) => {
    if(value.length === 0) return true
    const regex = /^\d+\.?\d*$/
    
    console.log('valid',regex.test(value), value)
    return regex.test(value)
  }
  return (
    <>
      <Modal closeOnOverlayClick={false} isOpen={isTransferServicesEditOpen} onClose={onTransferServicesEditClose} isCentered>
        <ModalOverlay />
        <ModalContent className={`transfer-create-modal`} maxWidth={"914px"} maxHeight={"auto"}>
          <ModalHeader className='store-transfer-edit-header'>
            Edit Transfer Details and Other Services
            <button className='transfer-create-modal__close-btn' onClick={onTransferServicesEditClose}><img src='/images/ui/close.svg' /></button>
          </ModalHeader>
          <ModalBody className={"store-transfer-edit-body"}>
            <div className='edit-outer-box'>
              <div className='edit-inner-box'>
                <label htmlFor="pistol_enabled" className='edit-inner-box-chechbox'>
                  <div className="transfer-fees-edit__checkbox-wrapper">
                    <input
                      type="checkbox"
                      className="transfer-fees-edit__checkbox"
                      onChange={(event) =>
                        onChangeHandler(
                          'pistol_enabled',
                          event.target.checked,
                          'status'
                        )
                      }
                      id="pistol_enabled"
                      checked={editValues.pistol_enabled}
                    />
                    <Image src="/images/ui/checked.svg" />
                  </div>
                  <span>Handgun</span>
                </label>
                <Box>
                  <InputGroup>
                    <InputLeftElement pointerEvents='none'><Box className = {editValues.pistol_fee ? 'default-color' : 'gray-color'}>$</Box>
                    </InputLeftElement>
                    <NumberInput
                      color={'black'}
                      value={editValues.pistol_fee || ''}
                    >
                      <NumberInputField
                        style={{ paddingLeft: '35px' }}
                        placeholder="Enter Handgun Fee"
                        onChange={(event) =>
                          onChangeHandler('pistol_fee', event.target.value, 'fee')
                        }
                      />
                    </NumberInput>
                  </InputGroup>
                </Box>
              </div>
              <div className='edit-inner-box'>
                <Box>Extra NICS Fee</Box>
                <Box>
                  <InputGroup>
                    <InputLeftElement pointerEvents='none'><Box className={editValues.nics_fee ? 'default-color' : 'gray-color'}>$</Box>
                    </InputLeftElement>
                    <NumberInput
                      color={'black'}
                      value={editValues.nics_fee || ''}
                    >
                      <NumberInputField
                        style={{ paddingLeft: '35px' }}
                        placeholder="Enter Extra NICS Fee"
                        onChange={(event) =>
                          onChangeHandler('nics_fee', event.target.value, 'fee')
                        }
                      />
                    </NumberInput>
                  </InputGroup>
                </Box>
              </div>
            </div>
            <div className='edit-outer-box'>
              <div className='edit-inner-box'>
                <Box className='edit-inner-box-chechbox'>
                  <label htmlFor="rifle_enabled" className='edit-inner-box-chechbox'>
                    <div className="transfer-fees-edit__checkbox-wrapper">
                      <input
                        type="checkbox"
                        className="transfer-fees-edit__checkbox"
                        onChange={(event) =>
                          onChangeHandler(
                            'rifle_enabled',
                            event.target.checked,
                            'status'
                          )
                        }
                        id="rifle_enabled"
                        checked={editValues.rifle_enabled}
                      />
                      <Image src="/images/ui/checked.svg" />
                    </div>
                    <span>Long Gun</span>
                  </label>
                </Box>
                <Box>
                  <InputGroup>
                    <InputLeftElement pointerEvents='none'><Box className={editValues.rifle_fee ? 'default-color' : 'gray-color'}>$</Box>
                    </InputLeftElement>
                    <NumberInput
                      color={'black'}
                      value={editValues.rifle_fee || ''}
                    >
                      <NumberInputField
                        style={{ paddingLeft: '35px' }}
                        placeholder="Enter Long Gun Fee"
                        onChange={(event) =>
                          onChangeHandler('rifle_fee', event.target.value, 'fee')
                        }
                      />
                    </NumberInput>
                  </InputGroup>
                </Box>
              </div>
              <div className='edit-inner-box'>
                <Box>NFA Fee</Box>
                <Box>
                  <InputGroup>
                    <InputLeftElement pointerEvents='none'><Box className={editValues.suppressor_fee ? 'default-color' : 'gray-color'}>$</Box>
                    </InputLeftElement>
                    <NumberInput
                      color={'black'}
                      value={editValues.suppressor_fee || ''}
                    >
                      <NumberInputField
                        style={{ paddingLeft: '35px' }}
                        placeholder="Enter NFA Fee"
                        onChange={(event) =>
                          onChangeHandler('suppressor_fee', event.target.value, 'fee')
                        }
                      />
                    </NumberInput>
                  </InputGroup>
                </Box>
              </div>
            </div>
            <div className='edit-outer-box'>
              <div className='edit-inner-box'>
                <Box className='edit-inner-box-chechbox'>
                  <label htmlFor="sbr_enabled" className='edit-inner-box-chechbox'>
                    <div className="transfer-fees-edit__checkbox-wrapper">
                      <input
                        type="checkbox"
                        className="transfer-fees-edit__checkbox"
                        onChange={(event) =>
                          onChangeHandler(
                            'sbr_enabled',
                            event.target.checked,
                            'status'
                          )
                        }
                        id="sbr_enabled"
                        checked={editValues.sbr_enabled}
                      />
                      <Image src="/images/ui/checked.svg" />
                    </div> <span>Other Firearms</span>
                  </label>
                </Box>
                <Box>
                  <InputGroup>
                    <InputLeftElement pointerEvents='none'><Box className={editValues.sbr_fee ? 'default-color' : 'gray-color'}>$</Box>
                    </InputLeftElement>
                    <NumberInput
                      color={'black'}
                      value={editValues.sbr_fee || ''}
                    >
                      <NumberInputField
                        style={{ paddingLeft: '35px' }}
                        placeholder="Enter Other Firearms Fee"
                        onChange={(event) =>
                          onChangeHandler('sbr_fee', event.target.value, 'fee')
                        }
                      />
                    </NumberInput>
                  </InputGroup>
                </Box>
              </div>
              <div className='edit-inner-box'>
                <Box>Discounts for multiple firearms</Box>
                <Box><InputGroup>
                  <InputLeftElement pointerEvents='none'><Box className={editValues.discount_multiple_firearms ? 'default-color' : 'gray-color'}>$</Box>
                  </InputLeftElement>
                  <NumberInput
                    color={'black'}
                    value={editValues.discount_multiple_firearms || ''}
                  >
                    <NumberInputField
                      style={{ paddingLeft: '35px' }}
                      placeholder="Enter Discount Amount"
                      onChange={(event) =>
                        onChangeHandler('discount_multiple_firearms', event.target.value, 'fee')
                      }
                    />
                  </NumberInput>
                </InputGroup>
                </Box>
              </div>
            </div>
          </ModalBody>
          <ModalFooter className={`store-transfer-edit-footer`}>
            <Button
              colorScheme="blue"
              onClick={onTransferServicesEditClose}
              background="#ffffff"
              color="#0C1E46"
              border="1px solid #0C1E46"
              padding="8px 11px"
              fontSize={"16px"}
              marginRight="20px"
              height={"35px"}
              width={"100px"}
              isDisabled = {isCreateDealerActionInprogress}
            >
              Cancel
            </Button>
            <Button
              colorScheme="blue"
              background="#0C1E46"
              height={"35px"}
              width={"100px"}
              fontSize={"16px"}
              padding="8px 20px"
              onClick={onSaveHandler}
              isDisabled={dealerActionsToBeSaved.length <= 0}
              isLoading={isCreateDealerActionInprogress}
            >
              Save
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}
 
export default StoreTransferEdit
